




























import Vue, { PropType } from 'vue'
import { IStudent } from '@/models/IStudent'
import { Actions } from '@/shared/Actions'

export default Vue.extend({
  name: 'StudentFilledForm',
  props: {
    student: {
      type: Object as PropType<IStudent>,
      default: (): IStudent => ({
        name: '',
        surname: '',
        addedBy: 'me',
        meta: ''
      })
    },
    roomId: {
      type: String as PropType<string>,
      required: true
    },
    allowRemoving: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isRemoveRequestProcessing(): boolean {
      return this.$store.state.isProcessing[Actions.REMOVE_STUDENT][this.roomId + this.student]
    },
    canEntryByRemove(): boolean {
      return this.student.meta === this.$store.state.user.meta
    },
    userUUID(): string {
      return this.$store.state.user.uuid
    },
    isEmpty(): boolean {
      return !(this.student.name && this.student.surname)
    },
    inputMockClass(): string {
      return this.isEmpty ? 'empty-input' : 'fielled-input'
    }
  },
  methods: {
    handleRemove(): void {
      this.$emit('onRemove', this.student)
    }
  }
})
